import React from 'react';

export function connectFC<TProps, TFCProps>(
  // We need to receive capitalized variable, to use it in JSX
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Component: React.FC<TFCProps> | ((props: TFCProps) => React.ReactElement<TFCProps> | null),
  useProps: (props: TProps) => Parameters<typeof Component>[0],
): React.FC<TProps> {
  return (props: TProps) => <Component {...useProps(props)} />;
}
